<div class="profileContainer">
  <div class="profileImageContainer">
    <img [src]="photoURL" alt="" class="profilePhoto">
    <div class="profilePhotoBorder"></div>
  </div>
</div>
<h2>Logged in as {{userName}}
</h2>
<button (click)="logOut()" class="text-main link-btn">LOGOUT</button>
